// Social accounts API
import { getAPI, token } from "@/api/params.js";

// How social presents in API path
const socialPaths = {
  youtube: "google",
  facebook: "facebook",
  twitter: "twitter"
};

// List of used socials
const SOCIALS = ["youtube", "facebook", "twitter"];

export const SOCIAL_LABELS = {
  youtube: "YouTube",
  facebook: "Facebook/Instagram",
  twitter: "Twitter"
};

// URL prefix for socials API functions
const getSocialsAPI = () => `${getAPI()}/user/socials`;

/**
 * Word 'internal' for account or page ID means, that it's ID that is using
 * in database, server-side and client-side, but not in social itself
 *
 * Word 'social' for account or page ID means that it's ID that is using
 * in social (google or facebook) API, but not in the Mangomolo application
 */

/**
 * Remove account by request to server API
 * @param {String} social Social name (youtube|facebook)
 * @param {Number} accountId Internal account ID
 */
export const disconnectAccount = async (social, accountId) => {
  const apiSocial = socialPaths[social];
  const reqURL = `${getSocialsAPI()}/${apiSocial}/${accountId}?token=${token}`;
  const disconnectResp = await fetch(reqURL, { method: "DELETE" });
  const respObj = await disconnectResp.json();

  if (!respObj.success) {
    throw new Error(respObj.error);
  }
};

/**
 * Return parsed accounts list
 */
export const getAccounts = async () => {
  const data = await fetchSocialsData();
  const accounts = parseAccounts(data);
  return accounts;
};

/**
 * Get unparsed accounts data
 */
async function fetchSocialsData() {
  const socaialsGettingURL = `${getSocialsAPI()}?token=${token}`;
  const resp = await fetch(socaialsGettingURL);

  const respObj = await resp.json();

  if (!respObj.success) {
    throw Error(respObj.error);
  }

  return respObj.data;
}

/**
 * Prepare accounts list to storing in local data
 * @param {Array} accounts Unprepared accounts list
 */
function parseAccounts(accounts) {
  const result = [];

  SOCIALS.forEach(social => {
    accounts[social].forEach(acc => {
      const accountData = {
        id: acc.id,
        social: social,
        label: "Loading",
        sync: false,
        metadata: acc
      };

      /** groups and pages lists for Facebook */
      if (social == "facebook") {
        accountData.groups = [];
        accountData.pages = [];
      }

      result.push(accountData);
    });
  });
  return result;
}
